import { render, staticRenderFns } from "./CheckpointModalComponent.vue?vue&type=template&id=4513cfa2"
import script from "./CheckpointModalComponent.vue?vue&type=script&lang=js"
export * from "./CheckpointModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports